<template>
  <v-card height="100px" dark>
    <v-container fluid pa0>
      <v-layout ma0 row>
        <v-flex>
          <h3>{{output}} </h3>
        </v-flex>
      </v-layout>
      <v-layout ma0 row>
        <v-flex v-if="!notComply" class="light-blue darken-2 text-white font-10px" pa0>
          {{message}}
        </v-flex>
        <v-flex v-else class="red darken-4 text-white font-10px">
          {{message}}
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>

export default {
  name: 'singleValue',
  components: {
    // Circle8
  },
  data () {
    return {
      volume: [],
      labels: [],
      useGB: '',
      useMB: '',
      output: '',
      message: '',
      notComply: false
    }
  },
  props: {
    func: {
      type: String
    },
    licen: {
      type: String
    },
    numberDevice: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    bpd: {
      type: Number
    }
  },
  mounted () {
    switch (this.func) {
      case 'storedDataSize':
        this.storedDataSize()
        break
      case 'availableDisk':
        this.availableDisk()
        break
      case 'numOfType':
        this.numOfType()
        break
      case 'estRetention':
        this.estRetention()
        break
    }
  },
  methods: {
    async storedDataSize () {
      this.message = 'Stored Data Size'
      this.useGB = (this.total / 1024 / 1024 / 1024).toFixed(2) // ใช้ไปกี่ GB แล้ว
      this.useMB = (this.total / 1024 / 1024).toFixed(2)
      if (this.useGB < 1) {
        this.output = this.useMB + ' MB'
      } else {
        this.output = this.useGB + ' GB'
      }
    },
    async availableDisk () {
      this.message = 'Available Disk'
      if (this.licen !== 'POC') {
        let GB = (this.total / 1024 / 1024 / 1024).toFixed(2)
        if (GB < 1) {
          let sizes = (this.licen * 90) * 1024 * 1024 * 1024
          let byte = sizes - this.total
          this.output = (parseInt(byte) / 1024 / 1024 / 1024).toFixed(2) * 1
          if (this.output <= 0) {
            this.output = 'Out of storage'
          } else {
            this.output = this.output + ' GB'
          }
        } else {
          this.output = ((this.licen * 90) - GB).toFixed(2) * 1
          if (this.output <= 0) {
            this.output = 'Out of storage'
          } else {
            this.output = this.output + ' GB'
          }
        }
      } else {
        // POC = Packgae 5GB
        if (this.licen === 'POC') {
          let GB = (this.total / 1024 / 1024 / 1024).toFixed(2)
          if (GB < 1) {
            let sizes = 450 * 1024 * 1024 * 1024
            let byte = sizes - this.total
            this.output = (parseInt(byte) / 1024 / 1024 / 1024).toFixed(2) * 1 + ' GB'
          } else {
            this.output = (450 - GB).toFixed(2) * 1 + ' GB'
          }
        }
      }
    },
    async numOfType () {
      this.message = 'Number of Device Type'
      this.output = this.numberDevice
    },
    async estRetention () {
      this.message = 'Estimate Data Retention'
      if (this.licen !== 'POC') {
        let GB = (this.total / 1024 / 1024 / 1024).toFixed(2)
        if (GB < 1) {
          let sizes = (this.licen * 90) * 1024 * 1024 * 1024
          let max = sizes - this.total
          let date = max / this.bpd
          this.output = date.toFixed(0) + ' Day'
        } else {
          let sizes = (this.licen * 90)
          let max = sizes - GB
          let gpd = this.bpd / 1024 / 1024 / 1024
          let date = max / gpd
          this.output = date.toFixed(0) + ' Day'
        }
      } else {
        // POC = package 5GB
        if (this.licen === 'POC') {
          let GB = (this.total / 1024 / 1024 / 1024).toFixed(2)
          if (GB < 1) {
            let sizes = 450 * 1024 * 1024 * 1024
            let max = sizes - this.total
            let date = max / this.bpd
            this.output = date.toFixed(0) + ' Day'
          } else {
            let sizes = 450
            let max = sizes - GB
            let gpd = this.bpd / 1024 / 1024 / 1024
            let date = max / gpd
            this.output = date.toFixed(0) + ' Day'
          }
        }
      }
      /* if (this.output < 90) {
          this.notComply = true
          this.output = this.output.toFixed(0) + ' Days'
          this.$emit('checkTCCA')
      } else {
          this.output = this.output.toFixed(0) + ' Days'
      } */
    }
  },
  watch: {
    total: {
      handler: function (total) {
        this.storedDataSize()
      }
    },
    numberDevice: {
      handler: function (numberDevice) {
        this.numOfType()
      }
    },
    licen: {
      handler: function (licen) {
        this.availableDisk()
      }
    },
    bpd: {
      handler: function (bpd) {
        this.estRetention()
      }
    }
  }
}
</script>

<style scoped>
.font-10px {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/singleValue.vue